export const defaultConfig = {
    maxMsgLength: 1024,
    runLevel: 'log',
    persist: true,
    persistTTL: 7 * 24 * 3600,
    storagePrefix: 'log',
}
